import PlaqueDynamicsPage from '@/pages/PlaqueDynamicsPage/PlaqueDynamicsPage.vue'

export default PlaqueDynamicsPage
